import { render, staticRenderFns } from "./infothek.vue?vue&type=template&id=9ccc6476&scoped=true&"
var script = {}
import style0 from "./infothek.vue?vue&type=style&index=0&id=9ccc6476&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccc6476",
  null
  
)

export default component.exports